import React from 'react';

const HeightMenu=() => {
    return (
        <div>
            <h1>
                Height(in):
            </h1>
            <form>
                <input type = "text" id = "height" placeholder="Any"></input>
            </form>
        </div>

    )
}

export default HeightMenu